module.exports = __webpack_public_path__ + "media/images/game/creative_task-425bb86a4275279032fb1cf55d5f5433.png";